import serverCall from "../../serverCall";

const getUserDetails = () => {
  try {
    const response = serverCall.get(`/users/get-profile`);
    return response;
  } catch (error) {
    throw error;
  }
};

const updateProfile = (body) => {
  try {
    const response = serverCall.patch(`/users/update-profile`, body);
    return response;
  } catch (error) {
    throw error;
  }
};
const changePassword = (oldPassword, currentPassword, type) => {
  try {
    const response = serverCall.post(
      `/users/changePassword?oldPassword=${oldPassword}&newPaasword=${currentPassword}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const UserService = {
  getUserDetails,
  updateProfile,
  changePassword,
};

export default UserService;
